import { Stack } from '@mui/material';
import { ZoomLevels } from 'enums';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import PaiButton from 'features/ui/base-components/pai-button';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface Props {
  campaignLoading: boolean;

  handleOpenCreateCampaignDialog(): void;
  disableCreate?: boolean;
}

const CreateCampaign: React.FC<Props> = ({ campaignLoading, handleOpenCreateCampaignDialog, disableCreate }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack className={classes.campaignBuilder} direction={'row'}>
      <Stack className={classes.campaignBuildingPanel} direction={'row'}>
        <Stack className={classes.panelContent}>
          {campaignLoading ? (
            <Stack justifyContent={'center'} alignItems={'center'} sx={{ height: '100%' }}>
              <PaiDotLoader inline={true} size={'large'} />
            </Stack>
          ) : (
            <Stack justifyContent={'center'} alignItems={'center'} sx={{ height: '100%' }}>
              <PaiButton text={t('createNewCampaign')} border={'rounded'} size={'large'} action={handleOpenCreateCampaignDialog} disabled={!!disableCreate} />
            </Stack>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  campaignBuilder: {
    height: 'calc(100vh - 60px - 32px)',
    fontSize: theme.typography.pxToRem(14),

    [theme.breakpoints.down('xl')]: {
      height: `calc((100vh / ${ZoomLevels.XL}) - 60px - 32px)`,
    },
    [theme.breakpoints.down(1300)]: {
      height: `calc((100vh / ${ZoomLevels.CUSTOM_LG}) - 60px - 32px)`,
    },
    [theme.breakpoints.down('lg')]: {
      height: `calc((100vh / ${ZoomLevels.LG}) - 60px - 32px)`,
    },
    [theme.breakpoints.down(1000)]: {
      height: `calc((100vh / ${ZoomLevels.CUSTOM_MD}) - 60px - 32px)`,
    },
    [theme.breakpoints.down('md')]: {
      height: `calc((100vh / ${ZoomLevels.MD}) - 60px - 32px)`,
    },
  },
  campaignBuildingPanel: {
    position: 'relative',
    flexBasis: '100%',
    maxWidth: '100%',
    // transition: '250ms',
    height: '100%',
    width: '100%',
    borderRadius: '6px',
    boxShadow: Shadows.GREY_SHADOW_MAIN,
    backgroundColor: '#fff',
    fontSize: theme.typography.pxToRem(14),
  },
  panelContent: {
    padding: '24px 16px 0 16px',
    flexBasis: '100%',
    maxWidth: '100%',
    position: 'relative',
  },
}));

export default CreateCampaign;
